package fr.manyverse.app.presentation.components.inventory

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Inventory2
import androidx.compose.material.icons.filled.Lightbulb
import androidx.compose.material.icons.filled.Map
import androidx.compose.material.icons.filled.Shield
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import fr.manyverse.app.domain.model.ItemCategory
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.icon_bomb
import manyverse.shared.generated.resources.icon_sword_cross
import manyverse.shared.generated.resources.inventory_category_clue
import manyverse.shared.generated.resources.inventory_category_consumable
import manyverse.shared.generated.resources.inventory_category_equipment
import manyverse.shared.generated.resources.inventory_category_map
import manyverse.shared.generated.resources.inventory_category_other
import manyverse.shared.generated.resources.inventory_category_weapon
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun ItemCategory.label(): String = when (this) {
    ItemCategory.WEAPON -> stringResource(Res.string.inventory_category_weapon)
    ItemCategory.EQUIPMENT -> stringResource(Res.string.inventory_category_equipment)
    ItemCategory.CONSUMABLE -> stringResource(Res.string.inventory_category_consumable)
    ItemCategory.MAP -> stringResource(Res.string.inventory_category_map)
    ItemCategory.CLUE -> stringResource(Res.string.inventory_category_clue)
    ItemCategory.OTHER -> stringResource(Res.string.inventory_category_other)
}

@Composable
fun ItemCategory.icon(): Painter = when (this) {
    ItemCategory.WEAPON -> painterResource(Res.drawable.icon_sword_cross)
    ItemCategory.EQUIPMENT -> rememberVectorPainter(Icons.Default.Shield)
    ItemCategory.CONSUMABLE -> painterResource(Res.drawable.icon_bomb)
    ItemCategory.MAP -> rememberVectorPainter(Icons.Default.Map)
    ItemCategory.CLUE -> rememberVectorPainter(Icons.Default.Lightbulb)
    ItemCategory.OTHER -> rememberVectorPainter(Icons.Default.Inventory2)
}
